import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { required, type } from "@/commons/utils/Rules";
import 'element-ui/lib/theme-chalk/display.css';
import PzBaseForm1 from "@/components/Flujo/Formularios/Formularios1/baseForm1";
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import { getRelacionesLaborales } from "@/routes/api/resources";

// Paso del formulario de nuevo socio, despues de la oferta: pide edad, ingresos y
// antiguedad laboral y los guarda sobre la solicitud ya creada (updateApplicant)
export default {
  name: 'PzPersonFormLaboralFucerep',
  components: {
    PzFormFlujo: PzFormFlujo
  },
  mixins: [PzBaseForm1],
  data: function data() {
    var _this = this;
    var check_Fecha = function check_Fecha(rule, value, callback) {
      localStorage.setItem('isjubilado', true);
      if (_this.formulario1.relacion_laboral_id != 4) localStorage.setItem('isjubilado', false);
      if (_this.formulario1.relacion_laboral_id != 4 && _this.formulario1.relacion_laboral_id != 16 && !value) {
        return callback(new Error(_this.$t('rules.incomplete')));
      }
      return callback();
    };
    return {
      relacion_laboral: [],
      reference: 'formulario1',
      formulario1: {
        fecha_nacimiento: '',
        relacion_laboral_id: '',
        fecha_ingreso: '',
        ingreso_mensual: '',
        jubilado: null,
        comprobante_domicilio: null,
        comprobante_ingresos: null,
        clearing: null
      },
      rules_formulario1: {
        fecha_nacimiento: [required('')],
        relacion_laboral_id: [required('')],
        ingreso_mensual: [required(''), type({
          field: '',
          type: 'number'
        })],
        fecha_ingreso: [{
          validator: check_Fecha,
          trigger: 'blur'
        }]
      },
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return Date.now() < time.getTime();
        }
      }
    };
  },
  computed: {
    isjubilado: function isjubilado() {
      return this.formulario1.relacion_laboral_id && (this.formulario1.relacion_laboral_id == '4' || this.formulario1.relacion_laboral_id == '16');
    }
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;
      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      return getRelacionesLaborales().then(function (res) {
        _this2.relacion_laboral = res.data;
      }).catch(function () {
        _this2.relacion_laboral = [];
      }).finally(function () {
        _this2.$store.dispatch('loader/down', {
          trigger: _this2.$options.name
        });
      });
    }
  }
};